import { Button, Form, Input, Modal, Select, TreeSelect } from "antd";
import React, { useEffect, useState } from "react";
import { GetDesignationsApi } from "../../../api/GetDesignationsApi";
import { GetTreeSelectUnitsApi } from "../../../api/GetTreeSelectUnitsApi";
import { GetUserRoleApi } from "../../../api/user-role/GetUserRoleApi";

const { Option } = Select;

function UsersFilterModal(props) {
  const [designations, setDesignations] = useState([]);
  const [unitsTree, setUnitsTree] = useState([]);
  const [roles, setRoles] = useState([]);
  const [form] = Form.useForm();

  function handleCancel() {
    setDesignations([]);
    setUnitsTree([]);
    props.handleCancel();
    form.resetFields();
  }

  useEffect(() => {
    if (props.visible) {
      getDesignations();
      getUnitsTree();
      getRole();
      form.setFields([
        { name: "employeeId", value: props.filterBy?.employeeId },
        { name: "username", value: props.filterBy?.username },
        { name: "name", value: props.filterBy?.name },
        props.filterBy?.status && {
          name: "status",
          value: props.filterBy?.status,
        },
      ]);
    }
  }, [props.visible]);

  async function getDesignations() {
    const apiResponse = await GetDesignationsApi();
    if (apiResponse.message === "success") {
      setDesignations(apiResponse.designations);
      props.filterBy?.designation &&
        form.setFields([
          {
            name: "designation",
            value: props.filterBy?.designation,
          },
        ]);
    }
  }

  async function getUnitsTree() {
    const apiResponse = await GetTreeSelectUnitsApi();
    if (apiResponse.message === "success") {
      setUnitsTree(apiResponse.units);
      props.filterBy?.unit &&
        form.setFields([
          {
            name: "unit",
            value: props.filterBy?.unit,
          },
        ]);
    }
  }

  async function getRole() {
    const apiResponse = await GetUserRoleApi();
    if (apiResponse.success) {
      setRoles(apiResponse.data);
      props.filterBy?.userRoleId &&
        form.setFields([
          {
            name: "userRoleId",
            value: props.filterBy?.userRoleId,
          },
        ]);
    }
  }

  function onFinish(values) {
    props.handleOk(values);
    handleCancel();
  }

  return (
    <Modal
      title="Filter Users"
      visible={props.visible}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose={true}
    >
      <Form
        name="basic"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        form={form}
      >
        <Form.Item label="Employee Id" name="employeeId">
          <Input placeholder="Employee Id" />
        </Form.Item>

        <Form.Item label="Username" name="username">
          <Input placeholder="User name" />
        </Form.Item>

        <Form.Item label="Name" name="name">
          <Input placeholder="Name" />
        </Form.Item>

        <Form.Item label="Status" name="status">
          <Select
            placeholder="Select status"
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            filterSort={(optionA, optionB) =>
              optionA.children
                .toLowerCase()
                .localeCompare(optionB.children.toLowerCase())
            }
          >
            <Option value={"Active"}>Active</Option>
            <Option value={"Disabled"}>Disabled</Option>
            <Option value={"Invited"}>Invited</Option>
          </Select>
        </Form.Item>

        <Form.Item label="Designation" name="designation">
          <Select
            showSearch
            placeholder="Select designation"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            filterSort={(optionA, optionB) =>
              optionA.children
                .toLowerCase()
                .localeCompare(optionB.children.toLowerCase())
            }
          >
            {designations.map((designation) => {
              return (
                <Option key={designation.id} value={designation.id}>
                  {designation.name}
                </Option>
              );
            })}
          </Select>
        </Form.Item>

        <Form.Item label="Unit" name="unit">
          <TreeSelect
            showSearch
            treeLine={true}
            dropdownStyle={{
              maxHeight: 400,
              overflow: "auto",
            }}
            treeData={unitsTree}
            placeholder="Select unit"
            treeDefaultExpandAll
            treeNodeFilterProp={"title"}
            showIcon={false}
            filterTreeNode
          />
        </Form.Item>

        <Form.Item label="Role" name="userRoleId">
          <Select
            placeholder="Select Role"
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            filterSort={(optionA, optionB) =>
              optionA.children
                .toLowerCase()
                .localeCompare(optionB.children.toLowerCase())
            }
          >
            {roles?.map((typ) => {
              return (
                <Option key={typ.id} value={typ.id}>
                  {typ.name}
                </Option>
              );
            })}
          </Select>
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <div className=" flex justify-end">
            <Button className="mr-3 w-28" onClick={() => handleCancel()}>
              Cancel
            </Button>
            <Button className="w-28" type="primary" htmlType="submit">
              Filter
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default UsersFilterModal;
